import React, { useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ApiHelper from "../../../Helpers/ApiHelper";
import Overlay from "../../SharedComponents/Overlay";

const PWD_Regex = /^(?=.*[a-z])(?=.*[^a-zA-Z\d\s:])(?=.*[A-Z])(?=.*[0-9]).{6,24}$/;

export function ChangePassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.user?.token);

  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [validation, setValidation] = useState({ newPassword: null, confirm: null });
  const [showOverlay, setShowOverlay] = useState(false);
  const [modal, setModal] = useState({ show: false, heading: "", text: "" });

  const onNewPassword = (value) => {
    setForm((f) => ({ ...f, newPassword: value }));
    setValidation((v) => ({ ...v, newPassword: !PWD_Regex.test(value) }));
  };

  const onConfirm = (value) => {
    setForm((f) => ({ ...f, confirm: value }));
    setValidation((v) => ({ ...v, confirm: value !== form.newPassword }));
  };

  const onSubmit = () => {
    setShowOverlay(true);
    ApiHelper.postAsync(
      "user/ChangePassword",
      { currentPassword: form.currentPassword, newPassword: form.newPassword },
      (result) => {
        setShowOverlay(false);
        if (result.status === 200 && result.data?.statusCode === 1) {
          setModal({ show: true, heading: t("success") || "Başarılı", text: result.data?.message || "Şifreniz güncellendi." });
        } else {
          setModal({ show: true, heading: "Hata", text: result.data?.message || t("requestFailed") });
        }
      },
      token
    );
  };

  const canSubmit = form.currentPassword && validation.newPassword === false && validation.confirm === false;

  return (
    <Container style={{ maxWidth: 480, marginTop: 80 }}>
      {showOverlay && <Overlay text="Şifre güncelleniyor" />}

      <h3 className="text-color-gray-dark fw-medium mb-4">{t("changePassword") || "Şifre Değiştir"}</h3>

      <Form>
        <Form.Group className="mb-3">
          <Form.Label className="text-color-gray-light">{t("currentPassword") || "Mevcut Şifre"}</Form.Label>
          <Form.Control
            type="password"
            className="default-text-input"
            onChange={(e) => setForm((f) => ({ ...f, currentPassword: e.target.value }))}
            autoComplete="current-password"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="text-color-gray-light">{t("newPassword") || "Yeni Şifre"}</Form.Label>
          <Form.Control
            type="password"
            className="default-text-input"
            isInvalid={validation.newPassword}
            onChange={(e) => onNewPassword(e.target.value)}
            autoComplete="new-password"
          />
          <Form.Control.Feedback type="invalid">
            {t("passwordCheckRules") || "Şifre kurallara uygun olmalı."}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label className="text-color-gray-light">{t("passwordAgain") || "Yeni Şifre (Tekrar)"}</Form.Label>
          <Form.Control
            type="password"
            className="default-text-input"
            isInvalid={validation.confirm}
            onChange={(e) => onConfirm(e.target.value)}
            autoComplete="new-password"
          />
          <Form.Control.Feedback type="invalid">
            {t("passwordsDoNotMatch") || "Şifreler eşleşmiyor."}
          </Form.Control.Feedback>
        </Form.Group>

        <Row>
          <Col>
            <Button className="button primary w-100 py-2" onClick={onSubmit} disabled={!canSubmit}>
              {t("save") || "Kaydet"}
            </Button>
          </Col>
        </Row>
      </Form>

      <Modal show={modal.show} onHide={() => setModal((m) => ({ ...m, show: false }))} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modal.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.text}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setModal((m) => ({ ...m, show: false }))}>
            {t("close") || "Kapat"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
